import { useState, useEffect, useRef, memo } from "react";
import dayjs from "dayjs";
import "../App.css";
import { toast } from "react-toastify";
import GetCurrencySymbol from "../components/GetCurrencySymbol";
import { DatePicker, Popconfirm, Select } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { getRoute } from "../api/routes";
import api from "../Interceptor";
import CustomModal from "./customModal/customModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCaretDown,
  faCaretUp,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import { CustomInput } from "./ui";
import ModalFooter from "./customModal/modalFooter";
import useModal from "../hooks/useModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchFilteredExpensesApi } from "../api/services/allExpenses";
import { validateFormHandler } from "../utils/validations/validateForm";
const { Option } = Select;

const ExpenseListProjectDetail = ({
  expenseByProjectId,
  selectedProject,
  selectedMilestone,
  onExpenseChange,
}) => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const baseCurrency = localStorage.getItem("baseCurrency");
  const [expenses, setExpenses] = useState([]);
  const [filteredExpenses, setFilteredExpenses] = useState([]);
  const [filterType, setFilterType] = useState("All");
  const [currencyView, setCurrencyView] = useState("ProjectCurrency");
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState(
    new Date().toISOString().split("T")[0],
  );
  const { isOpen, toggleModal } = useModal();
  const [errors, setErrors] = useState({});
  const [editExpense, setEditExpense] = useState(null);
  const tableRef = useRef(null);
  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("");
  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);

    const sorted = [...filteredExpenses].sort((a, b) => {
      if (field === "date") {
        return order === "asc"
          ? new Date(a.date) - new Date(b.date)
          : new Date(b.date) - new Date(a.date);
      }
      if (field === "amount") {
        const aAmount =
          currencyView === "BaseCurrency"
            ? a.amount / a.conversionRate
            : a.amount / a.conversionRate;
        const bAmount =
          currencyView === "BaseCurrency"
            ? b.amount / b.conversionRate
            : b.amount / b.conversionRate;

        return order === "asc" ? aAmount - bAmount : bAmount - aAmount;
      }
      return 0;
    });

    setFilteredExpenses(sorted);
  };
  const handleCurrencyChange = (value) => {
    setCurrencyView(value);
  };

  const handleStartDateChange = (date, dateString) => {
    setStartDate(dateString); // store as string (e.g. "2025-09-09")
  };
  const handleEndDateChange = (date, dateString) => {
    setEndDate(dateString);
  };
  const handleFilterTypeChange = (value) => {
    setFilterType(value);
  };
  useEffect(() => {
    if (expenses && filterType) {
      setFilteredExpenses(
        filterType === "All"
          ? expenses
          : expenses.filter(
              (expense) =>
                expense.type.toLowerCase() === filterType.toLowerCase(),
            ),
      );
    }
  }, [filterType, expenses]);

  const handleRefresh = () => {
    setCurrencyView("BaseCurrency");
    setFilterType("All");
    setStartDate("");
    setEndDate(new Date().toISOString().split("T")[0]);
    fetchFilteredExpensesApi({
      userRole: user.userRole.name,
      selectedProject,
      selectedMilestone,
      startDate,
      endDate,
    }).then((data) => setExpenses(data));
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(
        `${getRoute(
          "users",
          `${user.userRole.name}`,
          "expenses",
          false,
        )}?id=${id}`,
      );
      // setFilteredExpenses(prev => prev.filter(exp => exp._id !== id));
      //     dispatch(fetchAllExpenses({ userRole: user.userRole.name, projectId: selectedProject }));
      fetchFilteredExpensesApi({
        userRole: user.userRole.name,
        selectedProject,
        selectedMilestone,
        startDate,
        endDate,
      }).then((data) => setExpenses(data));
      toast.success("Expense deleted successfully");
      if (typeof onExpenseChange === "function") {
        onExpenseChange();
      }
    } catch (error) {
      toast.error("Failed to delete project");
    }
  };

  const handleUpdate = async (updatedExpense) => {
    const expenseId = updatedExpense._id;
    const hasChanged =
      updatedExpense.name !== editExpense.name ||
      updatedExpense.description !==
        (editExpense.description == undefined ? "" : editExpense.description) ||
      updatedExpense.amount !== editExpense.amount ||
      updatedExpense.type !== editExpense.type ||
      updatedExpense.date !== editExpense.date;

    const updatedPayload = {
      name: updatedExpense.name,
      description: updatedExpense.description || undefined,
      amount: updatedExpense.amount,
      type: updatedExpense.type,
      conversionRate: updatedExpense.conversionRate,
      date: updatedExpense.date,
      project: updatedExpense.project._id,
      id: expenseId,
    };
    const validationErrors = validateFormHandler({
      title: updatedPayload.name,
      price: updatedPayload.amount,
      date: updatedPayload.date,
    });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    toggleModal();
    if (!hasChanged) {
      toast.info("No changes detected.");
      return;
    }
    try {
      await api.put(
        `${getRoute(
          "users",
          `${user.userRole.name}`,
          "expenses",
          false,
        )}?id=${expenseId}`,
        updatedPayload,
      );
      toast.success("Expense updated successfully");
      setFilteredExpenses((prev) =>
        prev.map((exp) =>
          exp._id === updatedExpense._id ? updatedExpense : exp,
        ),
      );
      fetchFilteredExpensesApi({
        userRole: user.userRole.name,
        selectedProject,
        selectedMilestone,
        startDate,
        endDate,
      }).then((data) => setExpenses(data));
      if (typeof onExpenseChange === "function") {
        onExpenseChange();
      }
    } catch (error) {
      toast.error("Error updating project");
    }
  };

  const openEditModal = (expense) => {
    setEditExpense(expense);
    toggleModal();
  };

  const handleDownloadPDF = async () => {
    const input = tableRef.current;

    if (!input) return;

    const actionHeader = input.querySelector("th:nth-child(6)");
    const actionCells = input.querySelectorAll("td:nth-child(6)");

    if (actionHeader) actionHeader.style.display = "none";
    actionCells.forEach((cell) => (cell.style.display = "none"));

    await new Promise((resolve) => setTimeout(resolve, 100));

    const canvas = await html2canvas(input);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF();
    const imgWidth = 190;
    const pageHeight = pdf.internal.pageSize.height;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    let heightLeft = imgHeight;

    let position = 10;

    pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
    heightLeft -= pageHeight - position;

    while (heightLeft >= 0) {
      position = heightLeft - imgHeight + 10;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    }

    if (actionHeader) actionHeader.style.display = "";
    actionCells.forEach((cell) => (cell.style.display = ""));

    pdf.save("ExpenseList.pdf");
  };

  useEffect(() => {
    fetchFilteredExpensesApi({
      userRole: user.userRole.name,
      selectedProject,
      selectedMilestone,
      startDate,
      endDate,
    }).then((data) => setExpenses(data));
  }, [
    expenseByProjectId,
    selectedProject,
    selectedMilestone,
    startDate,
    endDate,
  ]);
  return (
    <div className="rounded-2xl shadow-lg bg-white h-full py-3 px-4 border-2 border-[#D5D7DA] font-customFont">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div style={{ fontFamily: "Noto Serif, sans-serif" }}>
          <h1 className="font-bold text-lg md:text-xl">Transaction List</h1>
        </div>
        <div className="flex flex-col md:flex-row gap-3 w-full md:w-auto mt-3 md:mt-0">
          <button
            onClick={handleRefresh}
            className="text-black border border-[#DCE3E3] px-3 py-2 rounded-md flex items-center justify-center w-full md:w-auto"
          >
            <FontAwesomeIcon icon={faRefresh}></FontAwesomeIcon>
          </button>
          <button
            className={`text-black border border-[#DCE3E3] px-3 py-1 rounded-md flex items-center justify-center w-full md:w-auto ${
              filteredExpenses.length === 0
                ? "border-gray-300 bg-gray-200 cursor-not-allowed"
                : "border-[#DCE3E3] bg-white hover:bg-gray-100"
            }`}
            onClick={handleDownloadPDF}
            disabled={filteredExpenses.length === 0}
          >
            <img src="/icons/Download.svg" className="w-5" alt="Download" />
            <span className="ms-2">Download PDF</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 my-4">
        <div>
          <DatePicker
            id="startDate"
            placeholder="Start Date"
            value={startDate ? dayjs(startDate) : null}
            onChange={handleStartDateChange}
            className={`border border-gray-300 rounded-md py-1 px-2 w-full ${
              startDate ? "ring-1 ring-blue-500 rounded-md" : ""
            }`}
          />
        </div>
        <div>
          <DatePicker
            id="endDate"
            placeholder="End Date"
            value={endDate ? dayjs(endDate) : null}
            onChange={handleEndDateChange}
            disabledDate={(current) => {
              const today = dayjs().endOf("day");
              return current && current > today;
            }}
            className={`border border-gray-300 rounded-md py-1 px-2 w-full ${
              endDate ? "ring-1 ring-blue-500 rounded-md" : ""
            }`}
          />
        </div>
        <div>
          <Select
            defaultValue="All"
            id="filterType"
            onChange={handleFilterTypeChange}
            className={`w-full ${
              filterType ? "ring-1 ring-blue-400 rounded-md" : ""
            }`}
            value={filterType}
          >
            <Option value="All">All Expense</Option>
            <Option value="Income">Income</Option>
            <Option value="Expense">Expense</Option>
          </Select>
        </div>
        <div>
          <Select
            value={currencyView}
            onChange={handleCurrencyChange}
            className={`w-full ${
              currencyView === "BaseCurrency"
                ? "ring-1 ring-blue-400 rounded-md"
                : ""
            }`}
          >
            <Option value="BaseCurrency">Base Currency</Option>
            <Option value="ProjectCurrency">Project Currency</Option>
          </Select>
        </div>
      </div>

      <div className="overflow-x-auto">
        {loading ? (
          <div className="flex justify-center items-center h-48 mt-20">
            <div className="spinner"></div>
          </div>
        ) : (
          <div className="relative w-full">
            {/* HORIZONTAL SCROLL (shared) */}
            <div className="overflow-x-auto">
              <div className="min-w-[800px] space-y-2">
                {/* ================= HEADER ================= */}
                <div className="rounded-lg border border-[#D5D7DA] shadow-sm bg-[#E9EAEB]">
                  <table className="w-full table-fixed">
                    <thead className="text-[#535862] font-semibold">
                      <tr>
                        <th
                          className="px-4 sm:px-6 py-3 text-left text-xs uppercase tracking-wider flex justify-between"
                          onClick={() => handleSort("date")}
                        >
                          Date
                          <span className="inline-flex flex-col items-center leading-none">
                            <FontAwesomeIcon
                              icon={faCaretUp}
                              className={`text-xs ${
                                sortField === "date" && sortOrder === "asc"
                                  ? "text-black"
                                  : "text-gray-400"
                              }`}
                            />
                            <FontAwesomeIcon
                              icon={faCaretDown}
                              className={`-mt-2 text-xs ${
                                sortField === "date" && sortOrder === "desc"
                                  ? "text-black"
                                  : "text-gray-400"
                              }`}
                            />
                          </span>
                        </th>
                        <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase tracking-wider">
                          Title
                        </th>
                        <th className="px-4 sm:px-6 py-3 text-start text-xs uppercase tracking-wider">
                          Type
                        </th>
                        <th
                          className="px-4 sm:px-6 py-3 text-start text-xs uppercase tracking-wider flex justify-between"
                          onClick={() => handleSort("amount")}
                        >
                          Transaction
                          <span className="inline-flex flex-col items-start leading-none">
                            <FontAwesomeIcon
                              icon={faCaretUp}
                              className={`text-xs ${
                                sortField === "amount" && sortOrder === "asc"
                                  ? "text-black"
                                  : "text-gray-400"
                              }`}
                            />
                            <FontAwesomeIcon
                              icon={faCaretDown}
                              className={`-mt-2 text-xs ${
                                sortField === "amount" && sortOrder === "desc"
                                  ? "text-black"
                                  : "text-gray-400"
                              }`}
                            />
                          </span>
                        </th>
                        {user.access !== process.env.REACT_APP_ACCESS_VIEW && (
                          <th className="px-4 sm:px-6 py-3 text-left text-xs uppercase tracking-wider">
                            Action
                          </th>
                        )}
                      </tr>
                    </thead>
                  </table>
                </div>
                {/* ================= BODY ================= */}
                <div className="max-h-[520px] overflow-y-auto rounded-lg border border-[#D5D7DA] shadow-md bg-white">
                  <table className="w-full table-fixed">
                    <tbody className="divide-y divide-gray-200 text-[#535862]">
                      {filteredExpenses.length === 0 ? (
                        <tr>
                          <td colSpan="6">
                            <div className="flex flex-col items-center justify-center my-20">
                              <i className="fa-solid fa-sack-dollar text-gray-400 text-5xl"></i>
                              <p className="text-gray-400 mt-4">
                                Please create an Expense to view its details.
                              </p>
                            </div>
                          </td>
                        </tr>
                      ) : (
                        filteredExpenses.map((expense) => (
                          <tr key={expense._id}>
                            <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm">
                              {new Date(expense.date).toLocaleDateString()}
                            </td>
                            <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm">
                              {expense.name}
                            </td>
                            <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-start">
                              <span
                                className={`inline-flex items-start px-2.5 py-0.5 rounded-full text-xs font-medium ${
                                  expense.type === "income"
                                    ? "bg-green-100 text-green-800"
                                    : "bg-red-100 text-red-800"
                                }`}
                              >
                                {expense.type.toLowerCase() === "income"
                                  ? "Income"
                                  : "Expense"}
                              </span>
                            </td>
                            <td
                              className={`px-4 sm:px-6 py-4 whitespace-nowrap text-sm text-start cursor-pointer ${
                                expense.type === "income"
                                  ? "text-green-800"
                                  : "text-red-800"
                              }`}
                            >
                              {currencyView === "BaseCurrency" && (
                                <GetCurrencySymbol currencyId={baseCurrency} />
                              )}
                              {currencyView === "BaseCurrency"
                                ? ` ${(
                                    expense.amount / expense.conversionRate
                                  ).toFixed(2)}`
                                : `${
                                    expense.project.currency.symbol
                                  } ${expense.amount.toFixed(2)}`}
                            </td>
                            {user.access !==
                              process.env.REACT_APP_ACCESS_VIEW && (
                              <td className="px-4 sm:px-6 py-4 whitespace-nowrap text-sm">
                                <div className="flex gap-2">
                                  <button
                                    className="w-8 h-8 bg-blue-100 hover:bg-blue-200 text-blue-600 rounded-lg flex items-center justify-center transition-colors"
                                    onClick={() => openEditModal(expense)}
                                  >
                                    <i className="fas fa-edit"></i>
                                  </button>
                                  <Popconfirm
                                    title="Are you sure you want to delete this expense?"
                                    onConfirm={() => handleDelete(expense._id)}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <button className="w-8 h-8 bg-red-50 hover:bg-red-100 text-red-600 rounded-lg flex items-center justify-center transition-colors">
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </Popconfirm>
                                </div>
                              </td>
                            )}
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <CustomModal
        isOpen={isOpen}
        onClose={toggleModal}
        modalTitle="Edit Expense"
      >
        {editExpense && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const updatedExpense = {
                ...editExpense,
                name: e.target.title.value,
                amount: parseFloat(e.target.price.value),
                date: e.target.date.value,
                description: e.target.description.value,
              };
              handleUpdate(updatedExpense);
            }}
            className="space-y-4"
          >
            <CustomInput
              type="text"
              name="title"
              label="Title"
              defaultValue={editExpense.name}
              message={errors.title}
              onChange={() => {
                if (errors.title) {
                  setErrors((prev) => ({ ...prev, title: undefined }));
                }
              }}
              requir="true"
            />
            <CustomInput
              type="number"
              name="price"
              label="Amount"
              step="any"
              defaultValue={editExpense.amount}
              message={errors.price}
              onChange={() => {
                if (errors.price) {
                  setErrors((prev) => ({ ...prev, price: undefined }));
                }
              }}
              requir="true"
            />
            <CustomInput
              type="date"
              name="date"
              label="Date"
              defaultValue={
                new Date(editExpense.date).toISOString().split("T")[0]
              }
              onChange={() => {
                if (errors.date) {
                  setErrors((prev) => ({ ...prev, date: undefined }));
                }
              }}
              max={new Date().toISOString().split("T")[0]}
              message={errors.date}
              requir="true"
            />
            <CustomInput
              as="textarea"
              label="Description"
              name="description"
              defaultValue={editExpense.description}
            />
            <ModalFooter onCancel={toggleModal} isLoading={loading} />
          </form>
        )}
      </CustomModal>
    </div>
  );
};

export default memo(ExpenseListProjectDetail);
